<div class="search-group">
    <input #search type="text" (keydown.enter)="$event.preventDefault()" placeholder="{{translate('Buscar')}}..."
        autocorrect="off" autocapitalize="off" spellcheck="off">
</div>
